module.exports = __webpack_public_path__ + "img/sol dark.c04db715.svg";